import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Image } from '@deal/components';
import { usePathContext } from '../../../context/PathContext.js';
import classNames from 'classnames';
import PlainText from '../../PlainText/index.js';
import { ListPathQuestionSchemaType } from '../../../generated/types.js';
import SuccessCheck from '../success-check.svg.js';
import styles from './styles.css.js';

var ImageSelectCard = function ImageSelectCard(_ref) {
  var _classNames, _classNames2, _classNames3;

  var choice = _ref.choice,
      image = _ref.image,
      disabled = _ref.disabled,
      question = _ref.question,
      isSelected = _ref.isSelected,
      onHandleChange = _ref.onHandleChange;
  var pathContext = usePathContext();
  var isSingleSelect = question.listSchemaType === ListPathQuestionSchemaType.SINGLE_SELECT_LIST;
  var buttonClasses = classNames(styles.common, (_classNames = {}, _defineProperty(_classNames, styles.placementDefault, pathContext.pathPlacement === 'default'), _defineProperty(_classNames, styles.selected, isSelected), _classNames));
  var cardContentClasses = classNames(styles.cardContent, (_classNames2 = {}, _defineProperty(_classNames2, styles.noImageContent, image === undefined), _defineProperty(_classNames2, styles.placementDefault, pathContext.pathPlacement === 'default'), _defineProperty(_classNames2, styles.imageContent, image !== undefined), _classNames2));
  var cardImageClasses = classNames((_classNames3 = {}, _defineProperty(_classNames3, styles.cardImageOnly, !choice.text), _defineProperty(_classNames3, styles.cardImageWithText, choice.text), _classNames3));
  return React.createElement("label", {
    className: styles.wrapper,
    htmlFor: choice.id
  }, React.createElement("input", {
    id: choice.id,
    disabled: disabled,
    name: isSingleSelect ? question.id : choice.id,
    type: isSingleSelect ? 'radio' : 'checkbox',
    className: styles.input,
    value: choice.id,
    checked: isSelected,
    onChange: function onChange(ev) {
      onHandleChange({
        choiceId: choice.id,
        //@ts-ignore The 'radio' or 'checkbox' value confuses typescript
        isChecked: ev.target.checked
      });
    }
  }), React.createElement("div", {
    className: buttonClasses
  }, image !== undefined && React.createElement("div", {
    className: styles.cardImageWrapper
  }, React.createElement(Image, {
    src: image.url,
    className: cardImageClasses,
    width: 250
  })), isSelected && React.createElement(SuccessCheck, {
    className: styles.successCheck
  }), React.createElement("div", {
    className: cardContentClasses
  }, choice.text && React.createElement("span", {
    className: styles.headline
  }, React.createElement(PlainText, {
    plainTextEntry: choice.text
  })), choice.subText && React.createElement("div", {
    className: styles.body
  }, React.createElement(PlainText, {
    plainTextEntry: choice.subText
  })))));
};

export default ImageSelectCard;
//# sourceMappingURL=index.js.map
